export const getTimeDifferenceInMinutes = (inputTime) => {
    const currentTime = new Date();
    const inputDate = new Date(inputTime);

    if (isNaN(inputDate)) {
        throw new Error("Invalid date input");
    }
    const timeDifference = inputDate - currentTime;
    const diffInMinutes = Math.floor(timeDifference / (1000 * 60));

    return diffInMinutes;
}


export const getTimeDifference = (inputTime) => {
    const currentTime = new Date();
    const inputDate = new Date(inputTime);

    if (isNaN(inputDate)) {
        throw new Error("Invalid date input");
    }

    const timeDifference = inputDate - currentTime;

    if (timeDifference < 0) {
        return { minutes: 0, seconds: 0 }; // Time has passed
    }

    const minutes = Math.floor(timeDifference / (1000 * 60));
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    return { minutes, seconds };
};



export const millisecondsToMinutes = (milliseconds) => {
    const minutes = milliseconds / 60000;
    return minutes <= 0 ? 1 : minutes;
}